import { call, put, takeLatest } from 'redux-saga/effects'

import { dashboardLoaderAC } from '../system/systemActionCreators'


import { getRefundsList } from 'model/dashboardRefunds/dRefundsAPI';
import { IdRefundsStateDataItem, typeRefundsFilters } from 'model/dashboardRefunds/dRefundsReducer';
import {
    dRefundsSetDataAC,
    dRefundsSetDataSagaAC,
    dRefundsSetPaginationAC
} from 'model/dashboardRefunds/dRefundsActionCreators';
import {
    paginationMapper,
    typePagination,
    typeRequestPagination
} from '../system/constants';
import { errorGenerator } from 'model/system/utils';


// Temp data list mapper
const tempDataMapper = (tempResponseData: any): IdRefundsStateDataItem[] => {
    return tempResponseData.map((item: IdRefundsStateDataItem) => {
        return (
            {
                amount: item.amount,
                appletVersion: item.appletVersion,
                cashierId: item.cashierId,
                date: item.date,
                fiscalSign: item.fiscalSign,
                fmId: item.fmId,
                id: item.id,
                receiptNumber: item.receiptNumber,
                store: (item.store?.id && item.store?.name) ? {id: item.store.id, name: item.store.name} : null,
                userId: item.userId,
                userName: item.userName,
                zreportNumber: item.zreportNumber,
                productsCount: item.productsCount

            }
        )
    })

}

// Get data function-generator
function* getData(payload: {  filters: typeRefundsFilters, paginationRequest: typeRequestPagination }) {

    let response = yield call(getRefundsList, payload)

    if (response.status === 200) {

        const tempData: IdRefundsStateDataItem[] = tempDataMapper(response.data.content)
        const pagination: typePagination = paginationMapper(response.data)

        yield put(dRefundsSetPaginationAC(pagination))

        yield put(dRefundsSetDataAC(tempData))

    } else {
        yield errorGenerator(response)
    }
}


// ---------------------------------------------------------------------------------------------------------------------
// Set Refunds list saga
export function* dRefundsSetDataWorker(actionObject: {
    type: string,
    payload: {
        filters: typeRefundsFilters,
        paginationRequest: typeRequestPagination
    }
}) {

    yield put(dashboardLoaderAC(true))

    yield getData(actionObject.payload)

    yield put(dashboardLoaderAC(false))

}

export function* dRefundsSetDataWatcher() {
    yield takeLatest(dRefundsSetDataSagaAC.type, dRefundsSetDataWorker)
}


